import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { NOTICE_FIRST_OPTIONS } from '@/pages/Onboarding/options/NoticeFirst/NOTICE_FIRST_OPTIONS';
import { getNoticeFirstTitleById } from '@/pages/Onboarding/options/NoticeFirst/utils/getNoticeFirst';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const NoticeFirstScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'NoticeFirst',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const noticeFirst = form.watch('notice_first');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['notice_first']>,
  ) => {
    form.setValue('notice_first', option.id);
  };

  const handleNextStep = () => {
    const noticeFirstTitle = getNoticeFirstTitleById(noticeFirst);
    userService.createOrUpdate({
      onboarding_data: {
        notice_first: noticeFirstTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>What's the First Thing You Notice?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="list">
          {NOTICE_FIRST_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={noticeFirst === option.id}
              control={form.control}
              option={option}
              name="notice_first"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="list"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!noticeFirst}
      />
    </OnboardingPage>
  );
};
